module.exports = __webpack_public_path__ + "assets/images/coin-5-print.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-5-print.png
// module id = 142
// module chunks = 1